import { useGetAddressQuery, useGetAddressPresentationQuery } from "../../../../address/apis/Address.api";
import { AddressNameDisplay } from "../../../../address/components/address/AddressDetail/AddressName";
import { toString as toStringAddress, PrimaryAddress } from "../../../../address/types/models/Address";
import * as crudgen from "../../../../share";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import { Button, IconButton, Stack, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";
import {ID} from "../../../../types/global.d";
import {useLocationFormState} from "./AddressAddForm";
import AddressAddFormProvider from "./AddressAddFormProvider";
import AddIcon from '@mui/icons-material/Add';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {DescriptionAlert} from "../../../../share";
import { useFormContext } from 'react-hook-form';
import {useStateSession} from "../../../../hooks/useAuth";

const EMPTY_PAGINATION = {
    items: [],
    totalItems: 0,
    page: 0,
    pageSize: 12,
    numPages: 0
}

const AddDialog = ({name}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showDialog, setShowDialog] = React.useState<boolean>(false)
    const {setValue} = useFormContext()

    return (
        <>
            <IconButton aria-label={ t`Add Address` } onClick={() => setShowDialog(true)} size="small">
                <AddIcon />
            </IconButton>
            <Dialog
                open={showDialog}
                fullScreen={fullScreen}
                onClose={() => setShowDialog(false)}>
                <DialogTitle><Trans>Add Address</Trans></DialogTitle>
                <DialogContent>
                    <DescriptionAlert/>
                    <AddressAddFormProvider
                        successAction={
                            (data) => {
                                setValue(name, data.id)
                                setShowDialog(false)
                            }
                        }
                        cancelButton={<Button onClick={() => setShowDialog(false)}><Trans>Cancel</Trans></Button>}
                        initialFormState={useLocationFormState}
                        redirectPath="."
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

const AddressFormSelect = ({type, name, label, prefix, required, onValueChange, filter = {}} :
                                        {type: string, name: string, label: string, prefix: string, required: boolean, onValueChange?: (option: any) => void, filter: {
                                                email: string,
                                                address: string,
                                                city: string,
                                                }
                                        })  => {

    const session = useStateSession()
    const [, setInputTerm, inputTerm] = useSearchDebounce();

    const { data = EMPTY_PAGINATION,
        isLoading,
        isFetching,
    } = useGetAddressPresentationQuery({
      list: {
        page: 0,
        pageSize: 12,
      },
      filter: {
            email: inputTerm || '',
            emailOr: true,
            address: inputTerm || '',
            addressOr: true,
            city: inputTerm || '',
            cityOr: true,
            ...filter,
      },
    })

    if (type === 'select') {
        return (
            <Stack direction="row" spacing={0.1} alignItems="center">
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetAddressQuery(PrimaryAddress.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringAddress }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><AddressNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/address/entities/Addresses/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    } else {
        return (
            <Stack direction="row" spacing={0.1} alignItems="center">
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetAddressQuery(PrimaryAddress.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringAddress }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><AddressNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/address/entities/Addresses/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    }
}

export default AddressFormSelect